import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ThfModule } from '@totvs/thf-ui';

import { ThfModalPasswordRecoveryComponent } from '../thf-modal-password-recovery/thf-modal-password-recovery.component';
import { ThfPageBackgroundModule } from '../thf-page-background/index';
import { ThfPageChangePasswordComponent } from './thf-page-change-password.component';
import { ThfPageChangePasswordService } from './thf-page-change-password.service';

/**
 * @description
 *
 * MÃ³dulo do template do thf-page-change-password.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    ThfModule,
    ThfPageBackgroundModule
  ],
  declarations: [
    ThfPageChangePasswordComponent
  ],
  entryComponents: [
    ThfModalPasswordRecoveryComponent
  ],
  providers: [
    ThfPageChangePasswordService
  ],
  exports: [
    ThfPageChangePasswordComponent
  ]
})
export class ThfPageChangePasswordModule { }
